import { FlexCol, FlexRow } from '@/components/common/Flex';
import Icon from '@/components/common/icons/Icon';
import InfoText from '@/components/common/InfoText';
import { Paragraph } from '@/components/common/Typography';
import { assert } from '@common/errors';
import { iconNameByIraType } from '@common/react/goals';
import { isNumber } from '@common/util/types';
import { useState } from 'react';
import { labelByIraType } from './helpers';
import { useOpenIraFlowContext } from './OpenIraFlow';
import OpenIraFlowStep from './OpenIraFlowStep';
import { useRetirementGoalContext } from './RetirementGoalDetailContainer';
import RetirementGoalOnboardingConfirmKeyValueStack from './RetirementGoalOnboardingConfirmKeyValueStack';

const OpenIraFlowReviewStep = () => {
    const { setStep, iraType, info, updateInfo } = useOpenIraFlowContext();
    assert(info);
    const iconName = iconNameByIraType[iraType];
    const { goalConfig } = useRetirementGoalContext();
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (
        !isNumber(info.riskScore) ||
        !isNumber(info.initialDepositPlan) ||
        !info.transactionSchedulePlan ||
        !info.fundingAccountId
    ) {
        console.warn('Missing required info; redirecting to FUNDING');
        setStep('FUNDING');
        return null;
    }

    return (
        <OpenIraFlowStep
            headerTitle={`Last step! Confirm the details for your ${labelByIraType[iraType]} IRA`}
            onBack={() => setStep('FUNDING')}
            onNext={() => {
                setIsSubmitting(true);
                updateInfo({
                    ...info,
                    lastCompletedRetirementStep: 'REVIEW',
                })
                    .then(() => setStep('TERMS'))
                    .finally(() => setIsSubmitting(false));
            }}
            nextButtonText="Start investing"
            isSubmitting={isSubmitting}
        >
            <Paragraph textColor="textMuted">
                Click anything you’d like to change. When you’re ready, click
                ‘Start investing’.
            </Paragraph>
            <RetirementGoalOnboardingConfirmKeyValueStack
                mt={12}
                initialDepositPlan={info.initialDepositPlan}
                transactionSchedulePlan={info.transactionSchedulePlan}
                fundingAccountId={info.fundingAccountId}
                isAccountComplete={false}
                accountTypeItem={{
                    key: 'Account type',
                    value: (
                        <FlexCol alignItems="flex-end" gap={1}>
                            <FlexRow alignItems="center" gap={3}>
                                <Icon
                                    name={iconName}
                                    color={goalConfig.color}
                                    size="lg"
                                />
                                <Paragraph>{`Plenty ${labelByIraType[iraType]} IRA`}</Paragraph>
                            </FlexRow>
                            <Paragraph color="textMuted">
                                Plenty direct indexing portfolios
                            </Paragraph>
                        </FlexCol>
                    ),
                }}
            />
            <InfoText iconName="LightBulb04" mt={2}>
                You can change, pause, or stop your investment at any time. If
                you do need to make a change, make sure to do it at least a
                couple of days before any money is scheduled to transfer from
                your connected bank account.
            </InfoText>
        </OpenIraFlowStep>
    );
};

export default OpenIraFlowReviewStep;
